// @flow
import { createMuiTheme } from "@material-ui/core/styles";
import { GreyText } from "./scss";

export const LightTheme = createMuiTheme({
  overrides: {
    MuiTypography: {
      root: {
        marginTop: "0px",
      },
    },
    MuiStepIcon: {
      completed: {
        color: "currentColor !important",
      },
      active: {
        color: "currentColor !important",
      },
    },
  },
});



// WEBPACK FOOTER //
// ./src/global/types/themes.js